export default __webpack_public_path__ + "static/media/TL.76346432.png";